import i18n from '../locales/i18n'
import swal from 'sweetalert2'
import { tratarErroDoBackParaString } from '../utils'

export class ModalDeErroNovoPadrao {
  constructor(erro, sobreporMensagem = false) {
    this.type = 'error'
    this.text = ''
    this.footer = ''

    const codigoErro = this.extrairCodigoErro(erro)

    // ter um erro_generico não significa que o erro é traduzível, por ser o valor padrão
    // das exceções de novo padrão
    this.ehErroTraduzivel = codigoErro !== 'erro_generico' && codigoErro !== null
    if (!this.ehErroTraduzivel) {
      return
    }

    const mensagemFooter = () => {
      if (codigoErro === 'pin_invalido') {
        return i18n.t('errosNovoPadrao.codigo')
      }

      return codigoErro
    }
    this.footer = mensagemFooter()

    // caso sobreporMensagem seja definido, iremos ignorar a mensagem enviada do backend
    // e no lugar usar o que temos no i18n local
    if (sobreporMensagem) {
      this.text = i18n.t(`errosNovoPadrao.${codigoErro}`)
    } else {
      this.text = tratarErroDoBackParaString(erro?.detail)
    }
  }

  extrairCodigoErro(erro) {
    // temos 3 casos possiveis:
    // 1. Erro é uma PontoTelException e tem o codigo de erro por estar no novo padrão
    // 2. Erro é uma ValidationError, que tem uma lista de erros de validação, onde usaremos
    // somente o primeiro erro da lista e vamos verificar se ele é um erro traduzível
    // 3. Outros casos vamos retornar null pois não encontramos o codigo_erro

    const ehArray = Array.isArray(erro?.body?.detail)
    const erroDetail = erro?.body?.detail
    const codigoDoErro = erroDetail?.ctx?.codigo_erro
    if (erro.codigo_erro) {
      return erro.codigo_erro
    } else if (ehArray && codigoDoErro) {
      return codigoDoErro
    }

    return null
  }

  criarModal() {
    return swal({
      type: this.type,
      text: this.text,
      footer: this.footer
    })
  }
}
